import { mediaMin } from '@spa/shared/theme';
import styled from 'styled-components';
import { Wrapper as TenantCounter } from '../TenantCounter/styles';

export const WrapperDesktop = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(4)};
  max-height: 50vh;
`;

export const WrapperMobile = styled(WrapperDesktop)`
  max-height: calc(100dvh - 150px);
`;

export const MainHeaderDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaMin.largeBreakpoint`
    align-items: flex-start;
    flex-direction: column;
    gap: ${props => props.theme.space(3)};

    ${TenantCounter} {
      align-self: flex-end;
    }
  `}
`;

export const MainHeaderMobile = styled(MainHeaderDesktop)`
  align-items: flex-start;
  flex-direction: column;
  gap: ${props => props.theme.space(3)};

  ${TenantCounter} {
    align-self: flex-end;
  }
`;

export const FixedDatesTitle = styled.h2`
  font-family: 'IntervalNextMed', sans-serif;
  font-size: ${props => props.theme.rem(32)};
  font-weight: 600;
  line-height: ${props => props.theme.rem(40)};
  color: ${props => props.theme.unisystem.calendar.fixedContracts.color};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.space(3)};
  width: 100%;
  overflow-y: scroll;
`;

export const Accordion = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.unisystem.calendar.fixedContracts.border};
  background-color: ${props => props.theme.unisystem.calendar.fixedContracts.itemBackground};
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.unisystem.calendar.fixedContracts.hoverBackground};
  }

  &.selected {
    background-color: ${props => props.theme.unisystem.calendar.fixedContracts.selectedBackground};
    border: 1px solid ${props => props.theme.unisystem.calendar.fixedContracts.selectedBorder};
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${props => props.theme.space(3)};
  font-size: ${props => props.theme.rem(16)};
  padding: ${props => props.theme.space(3)};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.space(2)};
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${props => props.theme.unisystem.calendar.fixedContracts.color};

  svg {
    width: 24px;

    path {
      fill: ${props => props.theme.unisystem.calendar.fixedContracts.arrowSvgColor};
    }
  }
`;

export const Subtitle = styled.div`
  font-family: 'IntervalNextReg', sans-serif;
  display: flex;
  align-items: center;
  gap: ${props => props.theme.space(2)};
  font-size: ${props => props.theme.rem(14)};
  text-decoration: underline;
  color: ${props => props.theme.unisystem.calendar.fixedContracts.instalmentsTitle};

  svg {
    width: 16px;
    height: 8px;
    transition: transform 0.2s ease-in-out;
  }

  ${props =>
    props.isSelected &&
    `
      color: ${props => props.theme.unisystem.calendar.fixedContracts.color};

      svg {
        transform: rotate(-180deg);

        path {
          stroke: ${props => props.theme.unisystem.calendar.fixedContracts.arrowSvgColorSelected};
        }
      }
    `}
`;

export const Instalments = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: ${props => props.theme.space(3)};
`;

export const Instalment = styled.li`
  display: flex;
  justify-content: space-between;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(18)};
  color: ${props => props.theme.unisystem.calendar.fixedContracts.instalmentColor};

  span:first-of-type {
    font-family: 'IntervalNextMed', sans-serif;
  }
`;
